const SUMSUB_SDK_SCRIPT_URL = 'https://static.sumsub.com/idensic/static/sns-websdk-builder.js'
const SUMSUB_SDK_SCRIPT_ID = 'sumsub-websdk-builder'

export const SUMSUB_APPLICANT_SUBMITTED = 'idCheck.onApplicantSubmitted'
export const SUMSUB_APPLICANT_RESUBMITTED = 'idCheck.onApplicantResubmitted'
export const SUMSUB_APPLICANT_STATUS_CHANGED = 'idCheck.onApplicantStatusChanged'
export const SUMSUB_APPLICANT_STATUS = 'idCheck.applicantStatus'
export const SUMSUB_APPLICANT_VERIFICATION_COMPLETED = 'idCheck.onApplicantVerificationCompleted'
export const SUMSUB_OVERLAY_CLOSE_DELAY_MS = 3000

const SUMSUB_CLOSE_MESSAGE_TYPES = new Set([
  SUMSUB_APPLICANT_SUBMITTED,
  SUMSUB_APPLICANT_RESUBMITTED,
])

const SUMSUB_REFRESH_KYC_MESSAGE_TYPES = new Set([
  SUMSUB_APPLICANT_SUBMITTED,
  SUMSUB_APPLICANT_RESUBMITTED,
  SUMSUB_APPLICANT_STATUS_CHANGED,
  SUMSUB_APPLICANT_STATUS,
  SUMSUB_APPLICANT_VERIFICATION_COMPLETED,
])

export type SumsubWebSdkInstance = {
  launch: (container: string | HTMLElement) => void
  destroy: () => void
}

type SumsubWebSdkBuilder = {
  init: (
    accessToken: string,
    updateAccessToken: () => Promise<string>,
  ) => {
    withConf: (conf: { lang?: string }) => {
      withOptions: (options: { addViewportTag?: boolean; adaptIframeHeight?: boolean }) => {
        onMessage: (handler: (type: string, payload: unknown) => void) => {
          build: () => SumsubWebSdkInstance
        }
      }
    }
  }
}

declare global {
  interface Window {
    snsWebSdk?: SumsubWebSdkBuilder
  }
}

export const loadSumsubWebSdkBuilder = (): Promise<SumsubWebSdkBuilder> => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Sumsub WebSDK requires a browser environment'))
  }

  if (window.snsWebSdk) {
    return Promise.resolve(window.snsWebSdk)
  }

  const existing = document.getElementById(SUMSUB_SDK_SCRIPT_ID) as HTMLScriptElement | null
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', () => {
        if (window.snsWebSdk) resolve(window.snsWebSdk)
        else reject(new Error('Sumsub WebSDK failed to load'))
      })
      existing.addEventListener('error', () => reject(new Error('Sumsub WebSDK failed to load')))
    })
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.id = SUMSUB_SDK_SCRIPT_ID
    script.src = SUMSUB_SDK_SCRIPT_URL
    script.async = true
    script.onload = () => {
      if (window.snsWebSdk) resolve(window.snsWebSdk)
      else reject(new Error('Sumsub WebSDK failed to load'))
    }
    script.onerror = () => reject(new Error('Sumsub WebSDK failed to load'))
    document.body.appendChild(script)
  })
}

export const shouldCloseSumsubOverlayOnMessage = (type: string): boolean => {
  return SUMSUB_CLOSE_MESSAGE_TYPES.has(type)
}

export const shouldRefreshKycOnSumsubMessage = (type: string): boolean => {
  return SUMSUB_REFRESH_KYC_MESSAGE_TYPES.has(type)
}
